import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-contact-box-sales-concierge',
    templateUrl: './contact-box-concierge.component.html',
    styleUrls: ['./contact-box-concierge.component.scss']
})

export class ContactBoxSalesConciergeComponent implements OnInit {

    @Output() buttonClicked: EventEmitter<void> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {

    }

    onButtonClicked() {
        this.buttonClicked.emit();
    }
}
